import * as actionTypes from './actionTypes'
import * as API from '../../api/Admin/ContactUs'

export const adminContactUsListAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.CONTACT_US_LIST_REQUEST, payload: data})
        return API.contactUsListApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.CONTACT_US_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.CONTACT_US_LIST_ERROR, payload:error})    
            })
    }
}

export const adminGetInTouchListAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.CONTACT_US_LIST_REQUEST, payload: data})
        return API.getInTouchListApi(data)
            .then(response => {             
        
                dispatch({type: actionTypes.CONTACT_US_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.CONTACT_US_LIST_ERROR, payload:error})    
            })
    }
}

export const sendContactUsReplayeAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.CONTACT_US_REPLAYE_REQUEST, payload: data})
        return API.contactUsReplayeApi(data)
            .then(response => {             
                dispatch({type: actionTypes.CONTACT_US_REPLAYE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.CONTACT_US_REPLAYE_ERROR, payload:error})    
            })
    }
}







// WEBPACK FOOTER //
// ./src/actions/Admin/ContactUs.js